import _ from 'lodash';
import React, { useMemo, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useQuery } from '@apollo/client';

import CustomTable from './custom-table';
import { GET_FIRST_CLICK_ANALYTICS } from '../../graphql';

import {
  Container,
  ContainerDropwdown,
  Dropdown,
  Text,
  Loader,
  Message,
  Title,
} from './styles';

const FirstClick = (props) => {
  const { projectId, segmentId } = props;

  const {
    loading,
    data = {},
    errors,
  } = useQuery(GET_FIRST_CLICK_ANALYTICS, {
    variables: { projectId, segmentId },
    fetchPolicy: 'no-cache',
  });

  const { treeTestFirstClick = [] } = data?.analytics || {};

  const [selectedTask, setSelectedTask] = useState({});

  const options = useMemo(() => (
    _.map(treeTestFirstClick, (item) => ({
      key: item?.id,
      value: item?.id,
      text: item?.title,
    }))
  ), [treeTestFirstClick]);

  useEffect(() => {
    if (!_.isEmpty(options)) {
      setSelectedTask(_.first(treeTestFirstClick));
    }
  }, [treeTestFirstClick, options]);

  const handleChange = (e, { value }) => {
    const selected = _.find(treeTestFirstClick, (item) => item?.id === value);
    setSelectedTask(selected);
  };

  if (loading) {
    return <Loader data-loader="first-click-loader" />;
  }

  if (errors) {
    return (
      <Message>
        Error while fetching analytics.
      </Message>
    );
  }

  return (
    <Container>
      <Title as="h3">First Click</Title>

      <ContainerDropwdown>
        <Dropdown
          value={selectedTask.id}
          fluid
          selection
          onChange={handleChange}
          options={options}
        />
        <Text>{selectedTask.description}</Text>
      </ContainerDropwdown>

      <CustomTable branches={selectedTask.branches} />
    </Container>
  );
};

FirstClick.propTypes = {
  projectId: PropTypes.string.isRequired,
  segmentId: PropTypes.string,
};

FirstClick.defaultProps = {
  segmentId: undefined,
};

export default FirstClick;
